/* eslint-disable global-require */
import { css } from '@emotion/react';
import { color } from './color';

import { font, fontSize } from './font';

const importRoboto = () => css`
    /* roboto-100normal - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-display: swap;
        font-weight: 100;
        src: local('Roboto Thin '), local('Roboto-Thin'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-100.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-100.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-100italic - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: italic;
        font-display: swap;
        font-weight: 100;
        src: local('Roboto Thin italic'), local('Roboto-Thinitalic'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-100italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-100italic.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-300normal - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-display: swap;
        font-weight: 300;
        src: local('Roboto Light '), local('Roboto-Light'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-300.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-300.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-300italic - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: italic;
        font-display: swap;
        font-weight: 300;
        src: local('Roboto Light italic'), local('Roboto-Lightitalic'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-300italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-300italic.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-400normal - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-display: swap;
        font-weight: 400;
        src: local('Roboto Regular '), local('Roboto-Regular'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-400.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-400.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-400italic - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: italic;
        font-display: swap;
        font-weight: 400;
        src: local('Roboto Regular italic'), local('Roboto-Regularitalic'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-400italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-400italic.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-500normal - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-display: swap;
        font-weight: 500;
        src: local('Roboto Medium '), local('Roboto-Medium'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-500.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-500.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-500italic - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: italic;
        font-display: swap;
        font-weight: 500;
        src: local('Roboto Medium italic'), local('Roboto-Mediumitalic'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-500italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-500italic.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-700normal - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-display: swap;
        font-weight: 700;
        src: local('Roboto Bold '), local('Roboto-Bold'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-700.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-700.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-700italic - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: italic;
        font-display: swap;
        font-weight: 700;
        src: local('Roboto Bold italic'), local('Roboto-Bolditalic'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-700italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-700italic.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-900normal - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-display: swap;
        font-weight: 900;
        src: local('Roboto Black '), local('Roboto-Black'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-900.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-900.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-900italic - latin */
    @font-face {
        font-family: 'Roboto';
        font-style: italic;
        font-display: swap;
        font-weight: 900;
        src: local('Roboto Black italic'), local('Roboto-Blackitalic'),
            url(${require('./fonts/typeface-roboto/files/roboto-latin-900italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto/files/roboto-latin-900italic.woff')})
                format('woff'); /* Modern Browsers */
    }
`;
const importRobotoMono = () => css`
    /* roboto-mono-100normal - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: normal;
        font-display: swap;
        font-weight: 100;
        src: local('Roboto Mono Thin '), local('Roboto Mono-Thin'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-100.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-100.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-100italic - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: italic;
        font-display: swap;
        font-weight: 100;
        src: local('Roboto Mono Thin italic'), local('Roboto Mono-Thinitalic'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-100italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */
                url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-100italic.woff')}) format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-300normal - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: normal;
        font-display: swap;
        font-weight: 300;
        src: local('Roboto Mono Light '), local('Roboto Mono-Light'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-300.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-300.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-300italic - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: italic;
        font-display: swap;
        font-weight: 300;
        src: local('Roboto Mono Light italic'), local('Roboto Mono-Lightitalic'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-300italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */
                url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-300italic.woff')}) format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-400normal - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: normal;
        font-display: swap;
        font-weight: 400;
        src: local('Roboto Mono Regular '), local('Roboto Mono-Regular'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-400.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-400.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-400italic - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: italic;
        font-display: swap;
        font-weight: 400;
        src: local('Roboto Mono Regular italic'), local('Roboto Mono-Regularitalic'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-400italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */
                url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-400italic.woff')}) format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-500normal - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: normal;
        font-display: swap;
        font-weight: 500;
        src: local('Roboto Mono Medium '), local('Roboto Mono-Medium'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-500.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-500.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-500italic - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: italic;
        font-display: swap;
        font-weight: 500;
        src: local('Roboto Mono Medium italic'), local('Roboto Mono-Mediumitalic'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-500italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */
                url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-500italic.woff')}) format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-700normal - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: normal;
        font-display: swap;
        font-weight: 700;
        src: local('Roboto Mono Bold '), local('Roboto Mono-Bold'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-700.woff2')}) format('woff2'),
            /* Super Modern Browsers */ url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-700.woff')})
                format('woff'); /* Modern Browsers */
    }

    /* roboto-mono-700italic - latin */
    @font-face {
        font-family: 'Roboto Mono';
        font-style: italic;
        font-display: swap;
        font-weight: 700;
        src: local('Roboto Mono Bold italic'), local('Roboto Mono-Bolditalic'),
            url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-700italic.woff2')}) format('woff2'),
            /* Super Modern Browsers */
                url(${require('./fonts/typeface-roboto-mono/files/roboto-mono-latin-700italic.woff')}) format('woff'); /* Modern Browsers */
    }
`;

export const globalStyle = css`
    ${importRoboto()}
    ${importRobotoMono()}

    *, *:before, *:after {
        box-sizing: inherit;
    }
    html {
        height: 100%;
        box-sizing: border-box;
    }
    html,
    p,
    button {
        color: ${color.white};
        font-family: ${font.regular};
    }
    p,
    button {
        font-size: ${fontSize.medium};
    }

    body {
        margin: 0px;
        padding: 0px;
        overflow-x: hidden;
        min-width: 320px;
        background: #000000;
        font-family: 'Roboto', 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-size: 13px;
        line-height: 1.4285em;
        color: #ffffff;
        height: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-font-smoothing: antialiased;
        -o-font-smoothing: antialiased;
    }

    #app,
    #app > div {
        height: 100%;
    }

    a {
        color: #4183c4;
        text-decoration: none;
    }

    a:hover {
        color: #1e70bf;
        text-decoration: none;
    }
`;
